import React from 'react'
import { View, StyleSheet } from '@react-pdf/renderer'
import CheckCircle from '@generators/pdfComponents/icons/CheckCircle'
import colors from '@settings/styleSettings'
import Text from './Text'
import NoRiskMessage from './NoRiskMessage'

const styles = StyleSheet.create({
  view: {
    marginTop: 15,
    marginBottom: 15,
    flexDirection: 'row',
  },
  column: {
    display: 'block',
  },
  icon: {
    marginRight: 8,
    marginTop: -3,
  },
  text: {
    marginTop: 4,
    fontSize: 12,
    marginRight: 24,
    color: colors.strongGray,
  },
  title: {
    color: colors.strongGreen,
    fontSize: 14,
    fontFamily: 'Inter-Bold',
  },
  line: {},
})

// Create Document Component
export const NoRiskRecommendation = () => {
  return (
    <View style={styles.view}>
      <View style={styles.icon}>
        {' '}
        <CheckCircle />
        {' '}
      </View>
      <View style={styles.column}>
        <Text style={styles.title}>TUDO CERTO!</Text>
        <Text style={styles.text}>
          Nenhuma alteração foi encontrada em seus dados! É muito importante
          manter o corpo bem para ter uma vida saudável. Para continuar assim,
          aqui vão algumas dicas simples que podem ajudar:
        </Text>
        <NoRiskMessage
          title="Alimentação saudável: "
          text="procure incluir em sua dieta alimentos naturais e ricos em nutrientes, como frutas, legumes, verduras, grãos integrais e proteínas magras."
        />
        <NoRiskMessage
          title="Prática de exercícios: "
          text="faça atividades físicas regularmente, pelo menos 30 minutos por dia. Caminhar, correr, pedalar, nadar, dançar, são ótimas opções para manter o corpo em movimento."
        />
        <NoRiskMessage
          title="Hidratação: "
          text="beba bastante água, pois ela ajuda a eliminar toxinas do organismo e manter o corpo hidratado."
        />
        <NoRiskMessage
          title="Descanso: "
          text="durma pelo menos 7 horas por noite, isso ajuda na recuperação do corpo e mente."
        />
        <NoRiskMessage
          title="Controle do estresse: "
          text="pratique atividades que ajudem a relaxar, como yoga, meditação, ou simplesmente tirar um tempo para si mesmo."
        />
      </View>
    </View>
  )
}
